import {
  useAccessTokenRoles,
  useDecodedAccessToken,
} from '@b-stock/fe-core/bstock-next/components'

export const useIsUserEligibleToBid = ({ sellerId }: { sellerId?: string }) => {
  const decodedToken = useDecodedAccessToken()
  const roles = useAccessTokenRoles()

  if (!decodedToken) return false

  const userHasActiveBuyerRole = roles?.buyer === 'ACTIVE'
  const userIsSeller = sellerId === decodedToken.accountId

  return userHasActiveBuyerRole && !userIsSeller
}
